<template>
  <div :style="`color:${textColor}`">
    <h1 class="text-5xl mb-5 leading-tight" v-html="text"></h1>
  </div>
</template>
<script>
export default {
  name: 'Title',
  props: {
    text: {
      type: String,
      required: true,
    },
    textColor: {
      type: String,
      required: true,
    },
  },
};
</script>
